

import { useContext, useEffect, useRef, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import { BanksContext } from '../../context/bank/BankContext';
import Message from '../../components/ui/Message';
import { ProductsContext } from '../../context/products/ProductContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';

// Tiempos de servicio (mismos valores que el API)
const COURSE_OPTIONS = [
    { value: 0, label: 'Sin tiempo (sale de una)' },
    { value: 1, label: 'Entradas' },
    { value: 2, label: 'Platos fuertes' },
    { value: 3, label: 'Postres' },
];





export const MenuPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);    
    const { banks } = useContext(BanksContext)
    //const { groups, merchants, addMenu, updateMenu,loadMerchantsAndGroups, clearSuggestions, suggestions } = useContext(MenusContext);
    const [existMenuMsg, setExistMenuMsg] = useState('');
    const [errorMessage, setErrorMessage] = useState(''); 
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState(''); 
    const { getMenus, addMenu, updateMenu } = useContext(ProductsContext);
    
    const [menus, setMenus] = useState([]); 
    var menu ;


    if(state){
        menu = state.menu;        
    }else{
        menu = {
            id: -1,
            parentId: null,
            name: '',
            lastname: '',
            course: 0
        }
    }
    
   
    const {formState, onInputChange } = useForm(menu);

   var { id, name, lastname, parentId, course } = formState

   useEffect(() =>{
       getMenus().then((menus) => {
        setMenus(menus);
    })
  }, [])

   useEffect(() =>{
     //var formValid = false;
     
     var formValid =  (
        name.length 
       
    );
     setIsFormValid(formValid);
   }, [name])

     
    const handleSave = async ()=>{
        if (!isFormValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos.");
            return;
        }
        var resp = "";

        var menu = formState;
        

        if(id > 0 ) {            
            resp = await updateMenu( menu );            
        } else {
            resp = await addMenu(menu);
        }
        if(resp == "success"){
            setSuccessMessage(id > 0 ? "Menú actualizado correctamente" : "Menú creado correctamente.");  
        }else{
            setErrorMessage(resp);
            setExistMenuMsg(resp);
        }
    }


    const removeSucessMessage = ()=>{
        setSuccessMessage('');
        navigate(-1);
       }

    const removeError = ()=>{
        setErrorMessage('');
       }


       

    return (
        
        <div className='container d-flex align-items-center justify-content-center mt-5' style={ styles.container }>
            

            <div className='col-md-6'>
            <h3>{ id > 0 ? 'Actualizar menú/categoría' : 'Crear menú/categoría'}</h3> 
            <hr />

            <form className="row g-3 " >
           
            <div className="mb-3 ">
                    <label htmlFor="parentIdSelect" className="form-label">Menú / Categoría</label>
                    <select id='parentIdSelect' className="form-select" name='parentId' value={parentId} onChange={ onInputChange } >
                    <option key={-1} value={-1} >Seleccione una opción</option>
                    <option key={0} value={0} >Nivel Superior</option>
                    {menus.length > 0  
                    ?
                    menus.map(menuPrincipal => (
                        <option key={menuPrincipal.id} value={menuPrincipal.id} selected={menuPrincipal.id == menu.id}>{menuPrincipal.name}</option>
                      ))
                    :
                    ''
                    }
                   </select>
                </div>

                <div className="mb-3">
                    <label htmlFor="courseSelect" className="form-label">Tiempo de servicio</label>
                    <select id='courseSelect' className="form-select" name='course' value={course ?? 0} onChange={ onInputChange } >
                        {COURSE_OPTIONS.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
                    </select>
                    <div className="form-text">
                        Los productos de esta categoría se marchan a cocina en este tiempo. "Sin tiempo" sale de una (por ejemplo, bebidas);
                        en una subcategoría toma el tiempo de su categoría.
                    </div>
                </div>
                

                <div className="mb-3">
                    <label htmlFor="nameInput" className="form-label">Nombre *</label>
                    <input 
                        id='nameInput'
                        type="text" 
                        className={`form-control${required.mark(!name)}`}
                        placeholder="Nombre"
                        name="name"
                        value={ name }
                        onChange={ onInputChange }
                        required
                    />
                    <div className="invalid-feedback">Campo requerido</div>
                </div>

                <div className="mb-3">
                    <label htmlFor="lastnameInput" className="form-label">Description</label>
                    <input 
                        id='lastnameInput'
                        type="text" 
                        className="form-control"
                        placeholder="Description"
                        name="lastname"
                        value={ lastname }
                        onChange={ onInputChange }
                        required
                    />
                </div>
                
                
                
                <div className='container d-flex align-items-center justify-content-center mt-5'>
                    <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                    <button type="button" onClick={handleSave} className="btn btn-primary ms-5">Guardar</button>
                    </div>
                </form>
                <div style={{height: '100px'}}></div>
            </div>

            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)'/> : ''
            }
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)'/> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)'/> : ''
            }
            
        </div>
    )
}


const styles = {
    container: {
        flex:1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
